import { useState } from 'react'
import type { ReactNode } from 'react'

import { haptic } from '../telegram'

/**
 * Строка, которая раскрывается на месте. Нужна везде, где вывод обязан вести
 * на шаг глубже, но уводить с экрана незачем: основания под карточкой, разбор
 * периода под плиткой. Заголовок — настоящая кнопка с aria-expanded, иначе
 * голосовой доступ не понимает, что тут что-то спрятано.
 */
export function Collapsible({
  title,
  note,
  defaultOpen = false,
  children,
}: {
  title: string
  note?: string
  defaultOpen?: boolean
  children: ReactNode
}) {
  const [open, setOpen] = useState(defaultOpen)
  return (
    <div className={`collapsible${open ? ' open' : ''}`}>
      <button
        type="button"
        className="collapsible-head"
        aria-expanded={open}
        onClick={() => {
          haptic('light')
          setOpen((current) => !current)
        }}
      >
        <span className="collapsible-title">
          <span className="ttl">{title}</span>
          {note && <span className="note">{note}</span>}
        </span>
        <svg className="collapsible-chevron" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
          <path d="M3.5 5.5 7 9l3.5-3.5" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      {open && <div className="collapsible-body">{children}</div>}
    </div>
  )
}
